import React, { useState } from 'react';
import { i18n } from '../../i18n/i18n';
import { useAppContext } from '../../context/AppContext';
import { setAdultsNeedApprovalApi } from '../../services/apiService';
import { showToast } from '../kid/Toast';

/**
 * Admin setting (2026-10-19, Jens): do grown-ups' tasks need another grown-up's approval?
 * Off (the default): a grown-up's task is approved the moment they finish it.
 */
const AdultApprovalSetting: React.FC = () => {
  const { current_family, refreshFamilyData } = useAppContext() as any;
  const on = current_family?.adults_need_approval === true;
  const [saving, setSaving] = useState(false);

  const toggle = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await setAdultsNeedApprovalApi(!on);
      await refreshFamilyData();
      showToast({ message: i18n.t('approval_setting.saved') });
    } catch {
      showToast({ message: i18n.t('common.error_generic'), tone: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="space-y-2">
      <h2 className="font-kid-heading font-extrabold text-xl px-1">{i18n.t('approval_setting.title')}</h2>
      <div className="rounded-kid-card border-2 border-kid-border dark:border-kid-border-dark bg-kid-card dark:bg-kid-card-dark p-4">
        <button
          type="button"
          role="switch"
          aria-checked={on}
          disabled={saving}
          onClick={toggle}
          className="w-full flex items-center gap-4 text-left min-h-[48px] disabled:opacity-60"
        >
          <span className="flex-1 font-bold text-lg">{i18n.t('approval_setting.label')}</span>
          <span
            aria-hidden
            className={`relative shrink-0 w-14 h-8 rounded-full border-2 transition-colors ${on ? 'bg-kid-green border-kid-green' : 'bg-kid-chip dark:bg-kid-chip-dark border-kid-border-strong dark:border-kid-border-strong-dark'}`}
          >
            <span className={`absolute top-0.5 w-6 h-6 rounded-full bg-white shadow transition-all ${on ? 'left-7' : 'left-0.5'}`} />
          </span>
        </button>
        <p className="text-base mt-2 text-kid-text-muted dark:text-kid-text-muted-dark">
          {i18n.t(on ? 'approval_setting.help_on' : 'approval_setting.help_off')}
        </p>
      </div>
    </section>
  );
};

export default AdultApprovalSetting;
